import styled from 'styled-components';

export default styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: rgba(0, 27, 59, 0.38);
  text-transform: uppercase;
`;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/components/pretitle.js